import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  DatePicker,
  Row,
  Col,
  message,
  Spin,
  Checkbox,
  Flex,
} from "antd";
import { MoneyCollectOutlined, DisconnectOutlined } from "@ant-design/icons"; // Example icons
import "../css/OrderTable.css";
import dayjs from "dayjs";
import orderService from "../../services/OrderLists";
import commonService from "../../services/commonService";
import { useParams } from "react-router-dom";
import { catchError } from "../../utils/errorHandler";
import usePermissions from '../../hooks/usePermissions';
const EditQuotation = ({ orderData, handleModalClose, fetchOrderDetails }) => {
  const { hasPermission } = usePermissions();
  console.log(orderData.data.payment.budget, "orderData");
  const [form] = Form.useForm();
  const { orderKey } = useParams();
  const [selectedRadioPayment, setSelectedRadioPayment] = useState(null); // For currency selection
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  // console.log(orderData.data);
  const [quotationData, setQuotationData] = useState({
    budget_without_discount: Number(orderData?.data?.payment?.budget_without_discount || 0) + Number(orderData?.data?.payment?.budget || 0),
    discount: orderData?.data?.payment?.budget_without_discount,
    currency: orderData?.data?.payment?.currency,
    reminder: true,
    reminder_mail_date: null,
    is_vat_inclusive: false,
  });

  const [dropdownDataPayment, setDropdownDataPayment] = useState({
    currency: [],
  }); // Initialize with empty currency array
  // Fetch currency data on component mount
  const [loading, setLoading] = useState(true); // Add loading state

  const [selectedRadio, setSelectedRadio] = useState(
    orderData?.data?.payment?.currency
  );
  // console.log(selectedRadio, "selected");
  useEffect(() => {
    const fetchCurrencyList = async () => {
      const response = await commonService.getCurrencyList();
      if (response.success) {
        setDropdownDataPayment({ currency: response?.data?.data?.currency });
      } else {
        message.error("Failed to load currency list");
      }
      setLoading(false); // Loading complete
    };

    fetchCurrencyList();
  }, []);

  useEffect(() => {
    if (
      dropdownDataPayment.currency &&
      dropdownDataPayment.currency.length > 0
    ) {
      // Check if "USD" exists, else fallback to the first element
      // const defaultCurrency = dropdownDataPayment.currency.includes("USD")
      //   ? "USD"
      //   : dropdownDataPayment.currency[0];
      // console.log(defaultCurrency, "defaut; curremcy");
      // setSelectedRadioPayment(defaultCurrency);
      setQuotationData((prev) => ({
        ...prev,
        currency: orderData?.data?.payment?.currency,
      }));
    }
  }, [dropdownDataPayment]);

  const handleRadioChange = (value) => {
     console.log(value, "value");
    setSelectedRadio(value);
    const amountPaid = parseFloat(orderData?.data?.payment?.amount_paid);
    if (amountPaid === 0 || hasPermission("can_edit_quotation_currency_as_superuser")) {
      setQuotationData((prev) => ({
        ...prev,
        currency: value,
      }));
    }
  };
  const handleVATChange = (e) => {
    setQuotationData((prevData) => ({
      ...prevData,
      is_vat_inclusive: e.target.checked, // Update VAT inclusive state
    }));
  };

  const handleAddPayment = async () => {
    setLoading(true);
    try {
      // Prepare payment data
      const paymentData = {
        ...quotationData,
        reminder_mail_date: quotationData.reminder_mail_date?.toISOString(), // Convert date to ISO string
      };
      console.log(quotationData , 'quotation')
      // Call the addPayment function from orderService
      const addPaymentResponse = await orderService.editPayment(
        orderKey,
        paymentData
      );

      if (addPaymentResponse.success) {
        message.success("Payment added successfully!");
        setLoading(false);

        handleModalClose();
        await fetchOrderDetails(orderKey);
        setSelectedCurrency(addPaymentResponse?.data?.currency_display);

        // Reset logic for currency based on amount_paid
        const amountPaid = parseFloat(orderData?.data?.payment?.amount_paid);
        setQuotationData({
          budget_without_discount: Number(orderData?.data?.payment?.budget_without_discount || 0) + Number(orderData?.data?.payment?.budget || 0),
          discount: orderData?.data?.payment?.budget_without_discount,
          currency: hasPermission("can_edit_quotation_currency_as_superuser")  ||  amountPaid === 0    ? selectedRadio : orderData?.data?.payment?.currency,
          reminder: true,
          reminder_mail_date: null,
          is_vat_inclusive: false,
        });
        form.resetFields(); // Reset the form fields after successful submission
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      await catchError(error);

      console.error("Error submitting form:", error);
    }
  };
  return (
    <Form
      form={form}
      layout="vertical"
      encType="multipart/form-data"
      style={{ marginTop: "1rem" }}>
      {loading ? (
        <Flex
          vertical
          align="center"
          justify="center"
          style={{ width: "100%" }}>
          <Spin tip="Loading currency options..." />
        </Flex>
      ) : (
        <>
          <Flex vertical style={{ width: "100%" }}>
            <Row gutter={16}>
              <Col lg={8}>
                <Form.Item label="Budget Without Discount" required>
                  <Input
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    value={quotationData.budget_without_discount} // Use quotationData state
                    suffix={
                      <MoneyCollectOutlined
                        style={{ color: "rgba(0, 0, 0, 0.25)" }}
                      />
                    } // Add the budget icon here
                    placeholder="Budget Without Discount"
                    onChange={(e) =>
                      setQuotationData({
                        ...quotationData,
                        budget_without_discount: e.target.value,
                      })
                    }
                  />
                </Form.Item>
              </Col>
              <Col lg={8}>
                <Form.Item label="Discount" required>
                  <Input
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    suffix={
                      <DisconnectOutlined
                        style={{ color: "rgba(0, 0, 0, 0.25)" }}
                      />
                    } // Add the discount icon here
                    value={quotationData.discount} // Use quotationData state
                    placeholder="Discount"
                    onChange={(e) =>
                      setQuotationData({
                        ...quotationData,
                        discount: e.target.value,
                      })
                    }
                  />
                </Form.Item>
              </Col>
              <Col lg={8}>
                <Form.Item label="Reminder Mail Date">
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={(current) =>
                      current && current < dayjs().startOf("day")
                    }
                    showTime
                    format="YYYY-MM-DD HH:mm A"
                    onChange={(date) =>
                      setQuotationData({
                        ...quotationData,
                        reminder_mail_date: date,
                      })
                    }
                  />
                </Form.Item>
              </Col>
            </Row>

            <div>
              <label style={{ color: "black" }}>
                <span style={{ color: "red" }}>*</span> Select Currency
              </label>
              <div
                className="custom-radio-container"
                style={{ marginTop: "10px" }}>
                {dropdownDataPayment.currency.length > 0 ? (
                  dropdownDataPayment.currency.map((currency) => {
                    const amountPaid = orderData?.data?.payment?.amount_paid;
                    const isSuperUser = hasPermission('can_edit_quotation_currency_as_superuser');
const isCurrencyLocked = !(parseFloat(amountPaid) === 0) && !isSuperUser;
                    const isCurrentCurrency = currency === orderData?.data?.payment?.currency;
                    // If locked, only current currency is enabled
                    const disabled = isCurrencyLocked ? !isCurrentCurrency : false;
                    return (
                      <div
                        key={currency}
                        style={{
                          display: 'inline-flex',
                          marginBottom: 8,
                        
                          borderRadius: 8,
                          background:
                            selectedRadio === currency && !disabled
                              ? '#36c6d3'
                              : disabled
                                ? '#f5f5f5'
                                : '#fff',
                          opacity: disabled ? 0.7 : 1,
                          justifyContent: 'center',
                          alignItems: 'center',
                          cursor: disabled ? 'not-allowed' : 'pointer',
                          transition: 'background 0.2s, opacity 0.2s, border 0.2s'
                        }}
                      >
                        <input
                          type="radio"
                          id={`custom-radio-${currency}`}
                          name="currency"
                          value={currency}
                          className="custom-radio-input"
                          checked={selectedRadio === currency}
                          disabled={disabled}
                          onChange={() => handleRadioChange(currency)}
                          style={{ display: 'none' }}
                        />
                        <label
                          htmlFor={`custom-radio-${currency}`}
                          className="custom-radio-label"
                          style={{
                            minWidth: '60px',
                            padding: '2px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            textAlign: 'center',
                            margin: 0,
                            cursor: disabled ? 'not-allowed' : 'pointer',
                            background: 'none',
                            
                            color:
                              selectedRadio === currency && !disabled
                                ? 'white'
                                : '#222'
                          }}
                        >
                          {currency}
                        </label>
                      </div>
                    );
                  })
                ) : (
                  <p>No currency options available</p>
                )}
              </div>
            </div>

            {/* <Row gutter={16} style={{ marginTop: "18px" }}>
            <Col sm={24}>
              <Form.Item label="Reason" required>
                <Input.TextArea
                  placeholder="Enter the reason"
                  onChange={(e) =>
                    setQuotationData({
                      ...quotationData,
                      reason: e.target.value,
                    })
                  }
                  rows={4} // Adjust the number of rows as needed
                />
              </Form.Item>
            </Col>
          </Row> */}

            {/* VAT Inclusive Checkbox */}
            <Row gutter={16} style={{ marginTop: "10px" }}>
              <Col xs={24}>
                <Form.Item>
                  <Checkbox
                    checked={quotationData.is_vat_inclusive}
                    onChange={handleVATChange}>
                    VAT Inclusive
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>

            <Flex
              style={{ width: "100%", marginBottom: "20px" }}
              align="flex-end"
              justify="flex-end">
              <Button
                onClick={handleAddPayment}
                type="primary"
                loading={loading}>
                Submit
              </Button>
            </Flex>
          </Flex>
        </>
      )}
    </Form>
  );
};

export default EditQuotation;
